import React, { useContext } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import "./style.scss";
import "./App.scss";


// context
import { AuthContext } from "./contexts/authContext";

// pages
import Landing from "./pages/landing/Landing";
import Auth from "./pages/authentication/Auth";
import NotFound from "./pages/notFound/NotFound";
import Invite from "./pages/invite/Invite";

// components
import DashboardNavbar from "./components/Navbar/DashboardNavbar/DashboardNavbar";
import NavDrawer from "./components/NavDrawer/NavDrawer";
import PageLoading from "./components/PageLoading/PageLoading";

// dashboard routes
import EvaluationRoutes from "./routes/evaluation/EvaluationRoutes";
import CatalogRoutes from "./routes/catalog/CatalogRoutes";
import AboutRoutes from "./routes/about/AboutRoutes";
import UsersRoutes from "./routes/users/UsersRoutes"; 


function App() {
  const { user, loading } = useContext(AuthContext);

  const Layout = () => {
    const layoutStyle = {
      width: "100%",
      height: "100dvh",
      display: "flex",
      flexDirection: "column",
      position: "relative",
      zIndex: 10,
    };
    const outletContainerStyle = {
      flex: 1,
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      overflow: "auto",
      background: "linear-gradient(135deg, #f8e5c3, #d7f0f5, #e6f2d9, #f9e6f2)",
    };

    if(loading){
      return <PageLoading/>
    }

    if (user) {
      return (
        <div className="theme-light" style={layoutStyle as React.CSSProperties}>
          <NavDrawer />
          <DashboardNavbar />
          <div style={outletContainerStyle as React.CSSProperties}>
            <Outlet />
          </div>
        </div>
      );
    } 
    return <Navigate to="/" />;
  };

  const LandingProtection = () => {
    const { user, loading } = useContext(AuthContext);
    if(loading){
      return <PageLoading/>
    }
    if (user === null) {
      return <Outlet />;
    }
    return <Navigate to="/dashboard/evaluation" />;
  };


  return (
    <div className="theme-light">
      <BrowserRouter>
        <div className="appContainer">
          <Routes>
            <Route element={<LandingProtection />}>
              <Route path="/" element={<Landing/>} />
              <Route path="/auth/signin" element={<Auth action="signin" />} />
              <Route path="/auth/signup" element={<Auth action="signup" />} />
              <Route path="/auth/resetpwrequest" element={<Auth action="resetpwrequest" />} />
              <Route path="/auth/resetpw" element={<Auth action="resetpw" />} />
            </Route>
            <Route>
              <Route path="/invite" element={<Invite/>}  />
            </Route>
            <Route element={<Layout />}>
            <Route path="/dashboard/users/*" element={<UsersRoutes />} />
            <Route path="/dashboard/catalog/*" element={<CatalogRoutes />} />
              <Route
                path="/dashboard/evaluation/*"
                element={<EvaluationRoutes />}
              />
              <Route
                path="/dashboard/about/*"
                element={<AboutRoutes />}
              />
            </Route>
           
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
